import {handleLogout} from "components/utils"; import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Col, Form, Row} from "react-bootstrap";
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import {VerticalTimelineElement} from 'react-vertical-timeline-component';
import DateTimePicker from "react-datetime-picker";
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';



export const BedView = (props: { cookieEntityQr: string, data: any, reloadMethod: any, caseStatus: string }) => {

    const [bedName, setBedName] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [oldDateTime, setOldDateTime] = useState<Date>(new Date());
    const [newEventDateTime, setNewEventDateime] = useState<Date>(new Date());
    const [err, setErr] = useState(null);
    useEffect(() => {
        if (props.data) {
            axios.get('/api/backend/inventory/item/fetch/id/' + props.data.bedId)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setBedName(resp.data.name)
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })

            setOldDateTime(new Date(props.data.eventDate))
            setNewEventDateime(new Date(props.data.eventDate))
        }

    }, [props.data])


    const handleUpdate = (e) => {
        e.preventDefault()
        setIsEdit(false)
        axios.post('/api/backend/ipd/case/audit/update/event/date/' + props.data.id + '?newEventDate=' + encodeURIComponent(newEventDateTime.toISOString()),{})
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setOldDateTime(newEventDateTime)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                setErr("* The date you are specifying is older than previous bed assignment event or case creation. Please validate the date.")
            })
    }


    return (
        <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{background: '#ebecff', color: 'black'}}
            contentArrowStyle={{borderRight: '7px solid  #ebecff'}}
            date={props.data.createdAt + " - " + props.data.createdByName.split("@")[0]}
            iconStyle={{background: "#ebecff", fontSize: 25, textAlign: "center"}}
            icon="🛌"
        >
            <div className="d-flex justify-content-between">
                <div>
                    {bedName && <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary align-self-center">Assigned Bed:</div>
                        <div className="fs-5"> {bedName}</div>
                    </div>}
                    {bedName && !isEdit && <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary align-self-center">Assigned On:</div>
                        <div className="fs-6"> {oldDateTime.toLocaleDateString("en-GB")}&nbsp;{oldDateTime.toLocaleTimeString("en-GB")}</div>
                        {props.caseStatus != "CLOSED" && <a href="#/" className="text-warning font-weight-bold"
                           onClick={e => {
                               e.preventDefault()
                               setErr(null)
                               setIsEdit(true)
                           }}>&#x270E;</a>}
                    </div>}
                    {bedName && isEdit && <div className="d-flex gap-1">
                        <div className="fs-6 text-secondary align-self-center">Assigned On:</div>
                        {newEventDateTime && <DateTimePicker onChange={setNewEventDateime} clearIcon={null} value={newEventDateTime} />}
                        <div><Button
                            className="btn btn-light btn-sm"
                            onClick={e => handleUpdate(e)}
                        >
                            <div className="text-primary font-weight-bold">&#10003;</div>
                        </Button>&nbsp;
                        <Button
                            className="btn btn-light btn-sm"
                            onClick={e => setIsEdit(false)}
                        >
                            <div className="remove font-weight-bold">X</div>
                        </Button></div>
                    </div>}




                    {!bedName && <div className="fs-6 text-secondary align-self-center">Bed Unassigned</div>}
                    {!bedName && !isEdit && <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary align-self-center">Unassigned On:</div>
                        <div className="fs-6"> {oldDateTime.toLocaleDateString("en-GB")}&nbsp;{oldDateTime.toLocaleTimeString("en-GB")}</div>
                        {props.caseStatus != "CLOSED" && <a href="#/" className="text-warning font-weight-bold"
                           onClick={e => {
                               e.preventDefault()
                               setIsEdit(true)
                           }}>&#x270E;</a>}
                    </div>}
                    {!bedName && isEdit && <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary align-self-center">Unassigned On:</div>
                        {newEventDateTime && <DateTimePicker onChange={setNewEventDateime} clearIcon={null} value={newEventDateTime} />}
                        <div><Button
                            className="btn btn-light btn-sm"
                            onClick={e => handleUpdate(e)}
                        >
                            <div className="text-success font-weight-bold">&#10003;</div>
                        </Button>&nbsp;
                            <Button
                                className="btn btn-light btn-sm"
                                onClick={e => setIsEdit(false)}
                            >
                                <div className="text-danger font-weight-bold">X</div>
                            </Button></div>
                    </div>}
                </div>
                {err &&
                    <div className="my-3 text-danger fs-7">{err}</div>
                }
            </div>

        </VerticalTimelineElement>
    );
}